import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigateWithFeedback } from '../utils/navigationFeedback';
import { useI18n } from '../i18n';

function LanguageSwitcher({ compact = false }) {
  const { language, languages, setLanguage, t } = useI18n();

  return (
    <div
      className={`language-switcher${compact ? ' language-switcher--compact' : ''}`}
      aria-label={t('nav.chooseLanguage')}
      role="group"
    >
      {languages.map((item) => (
        <button
          aria-pressed={language === item.code}
          className={language === item.code ? 'is-active' : undefined}
          key={item.code}
          onClick={() => setLanguage(item.code)}
          title={item.name}
          type="button"
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useI18n();

  const navItems = [
    { label: t('nav.products'), target: '/', section: 'catalog' },
    { label: t('nav.company'), target: '/', section: 'company' },
    { label: t('nav.documents'), target: '/', section: 'documents' },
    { label: t('nav.contacts'), target: '/', section: 'contacts' },
  ];

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const navigateTo = (target = '/', section) => {
    navigateWithFeedback({
      currentPath: location.pathname,
      navigate,
      section,
      target,
      headerOffset: 76,
      message: t('nav.alreadyHere'),
    });
    setIsMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <button className="brand-lockup" onClick={() => navigateTo('/')}>
          <img src="/assets/logo-clean.png" alt={t('brand.companyName')} />
          <small>{t('brand.madeWithSoul')}</small>
        </button>

        <nav className="site-nav" aria-label={t('nav.mainNavigation')}>
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => navigateTo(item.target, item.section)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="site-header__actions">
          <LanguageSwitcher />
          <button
            className="button button--header"
            onClick={() => navigateTo('/product')}
          >
            {t('nav.allCatalog')}
          </button>
          <button
            className="menu-toggle"
            aria-label={t('nav.openMenu')}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((value) => !value)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <nav className="mobile-nav" aria-label={t('nav.mobileNavigation')}>
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => navigateTo(item.target, item.section)}
            >
              {item.label}
            </button>
          ))}
          <button onClick={() => navigateTo('/product')}>{t('nav.allCatalog')}</button>
          <LanguageSwitcher compact />
        </nav>
      )}
    </header>
  );
}
